import { useState, useEffect } from "react";
import { toast } from "sonner";

export default function ContactEmailEditor({ settings, updateTheme, savingTheme }) {
  const [value, setValue] = useState(settings?.contact_email || "");

  useEffect(() => {
    setValue(settings?.contact_email || "");
  }, [settings?.contact_email]);

  const save = (e) => {
    e?.preventDefault();
    if (!value || !value.includes("@")) {
      toast.error("Enter a valid email address.");
      return;
    }
    updateTheme({ contact_email: value });
  };

  return (
    <form onSubmit={save} className="mt-5 flex flex-col sm:flex-row sm:items-end gap-3">
      <div className="flex-1 min-w-0">
        <label className="ww-label">Send notifications to</label>
        <input
          type="email"
          required
          data-testid="contact-email-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="ww-input"
          placeholder="contact@wisewit.ai"
        />
        <div className="mt-1 font-mono text-[10px] text-[#555]">
          Current: <span className="text-[#DFFF00]">{settings?.contact_email || "—"}</span>
        </div>
      </div>
      <button
        type="submit"
        data-testid="contact-email-save"
        disabled={savingTheme || value === (settings?.contact_email || "")}
        className="btn-primary disabled:opacity-50"
      >
        {savingTheme ? "Saving…" : "Save email"}
      </button>
    </form>
  );
}
